/**
 * Render paragraph text with preserved manual line breaks.
 * Translation: Render paragraph text with preserved manual line breaks.
 *
 * @param {string} text - Paragraph text content.
 * @returns {JSX.Element[]} Rendered paragraph fragments.
 */
const renderParagraphText = (text) =>
  text.split("\n").map((line, index) => (
    <span key={`${line}-${index}`}>
      {line}
      {index < text.split("\n").length - 1 ? <br /> : null}
    </span>
  ));

/**
 * Render the supported blog block types.
 * Translation: Render the supported blog block types.
 *
 * @param {{blocks: Array<Object>}} props - Block renderer props.
 * @returns {JSX.Element|null} Rendered block tree.
 */
const BlockRenderer = ({ blocks }) => {
  if (!blocks?.length) {
    return null;
  }

  return blocks.map((block, index) => {
    const key = `${block.type}-${index}`;

    if (block.type === "header") {
      const headingTag = `h${block.level || 2}`;
      const HeadingTag = headingTag;
      return <HeadingTag key={key}>{block.text}</HeadingTag>;
    }

    if (block.type === "nestedList") {
      return (
        <ul key={key}>
          {block.items.map((item, itemIndex) => (
            <li key={`${key}-${itemIndex}`}>{item}</li>
          ))}
        </ul>
      );
    }

    return <p key={key}>{renderParagraphText(block.text || "")}</p>;
  });
};

export default BlockRenderer;
